import {useTranslation} from "react-i18next";
import React, {useContext, useEffect, useState} from "react";
import {Breadcrumb, Button, Space, Spin, Table, Tag} from "antd";
import {PlusCircleOutlined} from "@ant-design/icons";
import {Link, Outlet, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import DB_OrgStructure from "../../../database/dictionary/org_structures";
import {Context} from "../../../App";
import ModalWindow from "../../modal";
import Search from "antd/es/input/Search";
import NextButton from "../../tech/next_button";


const OrgStructures = () => {
    const {token, user, setToken} = useContext(Context);
    const {getOrgStructures} = DB_OrgStructure(token);
    const {errorConnect} = ModalWindow();
    const navigate = useNavigate();
    const params = useLocation().state;
    const {t} = useTranslation();
    const p = new URLSearchParams(window.location.search)

    const [dataBeta, setDataBeta] = useState([])

    const [wait, setWait] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams({})
    const [search, setSearch] = useState({})
    const [expandedKeys, setExpandedKeys] = useState([])
    const [autoExpandParent, setAutoExpandParent] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [showLeafIcon] = useState(false)


    const columns = [
        {
            title: 'ID',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: t('name'),
            dataIndex: 'title',
            key: 'name',
            render: (name) => {

                const strTitle = name;
                const index = strTitle.toLowerCase().indexOf(searchValue.toLowerCase());

                const beforeStr = strTitle.substring(0, index)
                const afterStr = strTitle.slice(index + searchValue.length)
                const currentStr = strTitle.replace(beforeStr, "").replace(afterStr, "")

                const title =
                    index > -1 ?
                        (
                            <span>
              {beforeStr}
                                <span className={`site-tree-search-value`}>{currentStr}</span>
                                {afterStr}
            </span>
                        ) : (
                            <span>{strTitle}</span>
                        );

                return (title)
            }
        },
        {
            title: t('status'),
            dataIndex: 'status',
            key: 'status',
            render: (status) => (
                <>
                    <Tag color={status === 1 ? 'green' : 'volcano'} key={status}>
                        {status === 1 ? t('active') : t('disable')}
                    </Tag>
                </>
            ),
        },
        {
            title: "",
            width:'7%',
            render: (record) => {
                return(
                    <div className={'div-next-button'}>
                        <Link to={`${record.key}?${searchParams.toString()}`} state={{data: dataBeta}}>
                            <NextButton/>
                        </Link>
                    </div>
                )
            }
        }
    ];

    useEffect(() => {
        if (params && params.data) {
            setDataBeta(params.data)
        } else {
            window.scroll(0, 0)
            setWait(true)
            getOrgStructures()
                .then(res => {
                    setDataBeta(res.data.data_beta)
                    setWait(false)
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })
                .finally(() => {
                    setWait(false)
                })
        }
    }, [])

    useEffect(() => {
        if (p.get("page") > 1) {
            setSearch(prevState => ({
                ...prevState,
                page: p.get("page")
            }))
        } else {
            setSearch(current => {
                const {page, ...rest} = current
                return rest
            })
        }
        if (p.get("size") > 1) {
            setSearch(prevState => ({
                ...prevState,
                size: p.get("size")
            }))
        } else {
            setSearch(current => {
                const {size, ...rest} = current
                return rest
            })
        }

        if (p.has("selected")) {
            console.log(p.get("selected").split(",").map(e => parseInt(e)))
            setExpandedKeys(p.get("selected").split(",").map(e => parseInt(e)))
            // setAutoExpandParent(false)
            setSearch(prevState => ({
                ...prevState,
                selected: p.get("selected")
            }))
        } else {
            setSearch(current => {
                const {selected, ...rest} = current
                return rest
            })
        }
    }, [])


    const onSelect = (selectedKeysValue, info) => {
        navigate({
                pathname: `${selectedKeysValue}`,
                search: `?${searchParams.toString()}`
            },
            {state: {data: dataBeta}}
        );
    }

    // const onExpand = (expandedKeysValue) => {
    //     console.log(expandedKeysValue)
    //     // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    //     // or, you can remove all expanded children keys.
    //     setExpandedKeys(expandedKeysValue)
    //     setSearch(prevState => ({
    //         ...prevState, selected: expandedKeysValue.toString()
    //     }))
    //     setAutoExpandParent(false)
    // }

    const onExpandTable = (expanded, key) => {
        if (expanded) {
            setExpandedKeys(old => [...old, key])
        } else {
            setExpandedKeys(expandedKeys.filter(item => item !== key))
        }
    }

    useEffect(() => {
        setSearch(prevState => ({
            ...prevState, selected: expandedKeys.toString()
        }))
    }, [expandedKeys])

    useEffect(() => {
        if (searchValue.length !== 0) {
            let returnData: Array<number> = []
            dataBeta.map(item => {
                returnData = returnData.concat(searchData(item, null))
            })

            setExpandedKeys(returnData)
        }
    }, [searchValue])

    const searchData = (item, parent): [number] => {
        let returnData: Array<number> = [];
        if (item.title.toLowerCase().includes(searchValue.toLowerCase()) && parent != null) {
            returnData.push(parent.key)
        }

        if (item.children != null) {
            item.children.map(i => {
                let result = searchData(i, item)
                if (result.length !== 0) {
                    returnData.push(item.key)
                }
                returnData = returnData.concat(result)
            })
        }
        return returnData
    }



    // const defaultData = dataBeta;
    // const dataList = [];
    // const generateList = (data) => {
    //     for (let i = 0; i < data.length; i++) {
    //         const node = data[i];
    //         const { key, title } = node;
    //         dataList.push({
    //             key,
    //             title: title,
    //         });
    //         if (node.children) {
    //             generateList(node.children);
    //         }
    //     }
    // };
    // generateList(dataBeta);



    // const treeData = useMemo(() => {
    //     const loop = (data) =>
    //         data.map((item) => {
    //             const strTitle = item.title;
    //             const index = strTitle.toLowerCase().indexOf(searchValue.toLowerCase());
    //
    //             const beforeStr = strTitle.substring(0, index)
    //             const afterStr = strTitle.slice(index + searchValue.length)
    //             const currentStr = strTitle.replace(beforeStr, "").replace(afterStr, "")
    //
    //             const style_span = item.status === 1 ? "" : "disable"
    //             const title =
    //                 index > -1 ?
    //                     (
    //                         <span className={`span-tree ${style_span}`}>
    //           {beforeStr}
    //                             <span className={`site-tree-search-value span-tree`}>{currentStr}</span>
    //                             {afterStr}
    //         </span>
    //                     ) : (
    //                         <span className={`span-tree ${style_span}`}>{strTitle}</span>
    //                     );
    //             if (item.children) {
    //                 return {
    //                     title,
    //                     key: item.key,
    //                     children: loop(item.children),
    //                 };
    //             }
    //             return {
    //                 title,
    //                 key: item.key,
    //             };
    //         });
    //     return loop(defaultData);
    //     // }, [searchValue, dataBeta]);
    // }, [dataBeta]);

    // const getParentKey = (key, tree) => {
    //     let parentKey;
    //     for (let i = 0; i < tree.length; i++) {
    //         const node = tree[i];
    //         if (node.children) {
    //             if (node.children.some((item) => item.key === key)) {
    //                 parentKey = node.key;
    //             } else if (getParentKey(key, node.children)) {
    //                 parentKey = getParentKey(key, node.children);
    //             }
    //         }
    //     }
    //     return parentKey;
    // };

    // const onChange = (e) => {
    //     let value = ''
    //     if (e != null) {
    //         value = e.target.value;
    //     }
    //     const newExpandedKeys = dataList
    //         .map((item) => {
    //             if (item.title.toLowerCase().indexOf(value.toLowerCase()) > -1) {
    //                 return getParentKey(item.key, defaultData);
    //             }
    //             return null;
    //         })
    //         .filter((item, i, self) => {
    //             return item && self.indexOf(item) === i
    //         });
    //
    //
    //     setSearchValue(value);
    //     setAutoExpandParent(true);
    //     if (e != null) {
    //         setExpandedKeys(newExpandedKeys);
    //
    //         setSearch(prevState => ({
    //             ...prevState, selected: newExpandedKeys.toString()
    //         }))
    //     }
    // };

    const onSearch = (e) => {
        setSearchValue(e)
    }

    useEffect(() => {
        setSearchParams(search)
    }, [search])



    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('org_structures')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>

                        <Button type={'primary'} shape={'round'} icon={<PlusCircleOutlined/>}
                                onClick={() =>  navigate({
                                        pathname: 'new',
                                        search: `?${searchParams.toString()}`
                                    },
                                    {state: {data: dataBeta}}
                                )}>{t('add')}</Button>
                    </Space>
                </Space>

                <Search
                    placeholder={t('name')}
                    allowClear
                    enterButton={t('search')}
                    size="large"
                    onSearch={onSearch}
                    // onChange={onChange}
                    // value={searchValue}
                    style={{
                        marginBottom: 8,
                    }}
                />

                <Table
                    style={{'--cursor': "auto" }}
                    columns={columns}
                    dataSource={dataBeta}
                    id={'key'}
                    size={'small'}
                    expandable={{
                        expandedRowKeys:expandedKeys,
                        onExpand:(expanded, record) => {
                            onExpandTable(expanded, record.key)
                        }
                    }}
                    pagination={false}
                />

                {/*<Tree*/}
                {/*    onExpand={onExpand}*/}
                {/*    autoExpandParent={autoExpandParent}*/}
                {/*    onSelect={onSelect}*/}
                {/*    treeData={treeData}*/}
                {/*    expandedKeys={expandedKeys}*/}
                {/*    showLine={{showLeafIcon }}*/}
                {/*    showIcon={false}*/}
                {/*    style={{padding:'20pt'}}*/}
                {/*    titleRender={(nodeData) => {*/}
                {/*        if (nodeData.status === 1) {*/}
                {/*            return(*/}
                {/*                <>*/}
                {/*                    <span>{nodeData.key} {nodeData.title}</span>*/}
                {/*                </>*/}

                {/*            )*/}
                {/*        } else {*/}
                {/*            return (*/}
                {/*                <>*/}
                {/*                    <Typography.Text type={"secondary"} style={{fontSize:'medium', padding:'0 10pt'}}>{nodeData.key}</Typography.Text>*/}
                {/*                    <Typography.Text type={"secondary"} style={{fontSize:'medium', padding:'0 0pt'}}>{nodeData.title}</Typography.Text>*/}
                {/*                </>*/}
                {/*            )*/}
                {/*        }*/}
                {/*    }}*/}
                {/*/>*/}

            </div>
            <Outlet/>
        </Spin>
    )
}

export default OrgStructures;